var SuggestionMenuPositions;
(function (SuggestionMenuPositions) {
    SuggestionMenuPositions["Top"] = "top";
    SuggestionMenuPositions["Bottom"] = "bottom";
})(SuggestionMenuPositions || (SuggestionMenuPositions = {}));
var HorizontalPositions;
(function (HorizontalPositions) {
    HorizontalPositions["Left"] = "left";
    HorizontalPositions["Center"] = "center";
    HorizontalPositions["Right"] = "right";
})(HorizontalPositions || (HorizontalPositions = {}));

export { HorizontalPositions, SuggestionMenuPositions };
